import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicAccountChatPasswordSetParamsRawI,
	LWApiPublicAccountChatPasswordSetResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/chatPassword/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { ACCOUNT_CHATPASSWORD_GET_QUERY_KEY } from './useGet';

const useAccountChatPasswordSet = () => {
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicAccountChatPasswordSetResultRawI,
		ApiErrorI,
		LWApiPublicAccountChatPasswordSetParamsRawI
	>({
		mutationFn: (params) => api.account.chatPassword.apiRaw.set(params),

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [ACCOUNT_CHATPASSWORD_GET_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useAccountChatPasswordSet;
